const popUp = '<div class="close-x"><form action="" id="formular-produs-configurabil" class="formular"><h4 class="titlu-form">Alte dimensiuni pentru produsul dorit?</h4><p class="subtitlu-form">Consultantul Mobexpert te va ajuta să îl configurezi la dimensiunile dorite</p><div class="line-wrapper"><label for="magazin">Alege cel mai apropiat Magazin *</label><div class="custom-select"><select name="Magazin" id="magazin" required><option value="" disabled selected>Alege magazinul</option><option value="Pipera, București, Șos. Fabrica de Glucoză nr. 21" id="M-Pipera" class="optiune-magazin">Pipera, București, Șos.Fabrica de Glucoză nr. 21</option><option value="Băneasa, București, Șos. București-Ploiești nr. 44C" id="M-Baneasa" class="optiune-magazin">Băneasa, București, Șos. București-Ploiești nr. 44C</option><option value="Militari, București, Autostrada București-Pitești nr. 2, Chiajna" id="M-Militari" class="optiune-magazin">Militari, București, Autostrada București-Pitești nr. 2, Chiajna</option><option value="Pantelimon, București, Șos. Vergului nr. 18" id="M-Pantelimon" class="optiune-magazin">Pantelimon, București, Șos. Vergului nr. 18</option><option value="Brașov, Calea București nr. 105A" id="M-Brasov" class="optiune-magazin">Brașov, Calea București nr. 105A</option><option value="Constanța, B-dul Aurel Vlaicu nr. 271" id="M-Constanta" class="optiune-magazin">Constanța, B-dul Aurel Vlaicu nr. 271</option><option value="Iași, Șos. Păcurari nr. 121" id="M-Iasi" class="optiune-magazin">Iași, Șos.Păcurari nr. 121</option><option value="Oradea, Calea Aradului nr. 62 - Complex ERA Shoping Park" id="M-Oradea" class="optiune-magazin">Oradea, Calea Aradului nr. 62 - Complex ERA Shoping Park</option><option value="Pitești, DN65B km 6, Bradu - Complex Comercial Supernova Pitești" id="M-Pitesti" class="optiune-magazin">Pitești, DN65B km 6, Bradu - Complex Comercial Supernova Pitești</option><option value="Sibiu, DN1 Km 306, Șelimbăr - Shoping City Sibiu" id="M-Sibiu" class="optiune-magazin">Sibiu, DN1 Km 306, Șelimbăr - Shoping City Sibiu</option><option value="Suceava, Calea Unirii nr. 27B - Shopping City Suceava" id="M-Suceava" class="optiune-magazin">Suceava, Calea Unirii nr. 27B - Shopping City Suceava</option><option value="Timișoara, B-dul Liviu Rebreanu nr. 152-154" id="M-Timisoara" class="optiune-magazin">Timișoara, B-dul Liviu Rebreanu nr. 152-154</option></select></div><p id="magazin-error" class="error-txt"></p></div><div class="line-wrapper"><label for="nume">Nume și Prenume *</label><input type="text" name="Nume si Prenume" id="nume" class="" required /><p id="nume-error" class="error-txt"></p></div><div class="line-wrapper"><label for="telefon">Telefon *</label><input type="text" name="Telefon" id="telefon" class="" placeholder="07xx-xxx-xxx" required /><p id="telefon-error" class="error-txt"></p></div><div class="line-wrapper"><label for="email">E-mail *</label><input type="email" name="E-mail" id="email" class="" placeholder="exemplu@adresa-de-email.ro" required /><p id="email-error" class="error-txt"></p></div><div class="line-wrapper check-wrapper"><input type="checkbox" id="aprovs" class="" name="Aprobare Contact si Termeni si Conditii" unchecked required /><label for="aprovs" class="checkbox-txt">Sunt de acord să fiu contactat de Mobexpert, cu <a class="link" href="https://mobexpert.ro/pages/termeni-si-conditii" target="_blank" title="Termeni și condiții">Termenii și condițiile</a> și cu <a class="link" href="https://mobexpert.ro/pages/politica-de-confidentialitate" target="_blank" title="Politica de confidențialitate">Politica de confidențialitate</a> a site-ului. </label></div><p id="check-error" class="error-txt"></p><div class="line-wrapper"><input type="button" id="Aplica-Produs-Configurabil" class="buton-form" value="Trimite" /></div></form></div>';
 const newPopUp = document.createElement("div");
                              newPopUp.setAttribute('class','formular-wrapper ascuns');
                              const popUpTrigger = document.querySelector('#produs-configurabil-formular-trigger');

                              const websiteNode = document.querySelector('.website-wrapper');
                              document.body.insertBefore(newPopUp, websiteNode);
                              newPopUp.innerHTML = popUp;
                              createSelect();
                              const openPopUp = function(){
                                newPopUp.classList.remove('ascuns');
                                document.body.style = 'overflow:hidden'; 
                              };
                              const closePopUp = function(){
                                newPopUp.classList.add('ascuns');
                                document.body.style = 'overflow:auto';
                              };

                              popUpTrigger.addEventListener('click', openPopUp);
                              newPopUp.addEventListener('click', (e)=>{

                                if (!e.target.closest('#formular-produs-configurabil')){
                                  closePopUp();
                                }
                              });      

                              /*JS creare SELECT */
                              function createSelect(){
                                let x, l, ll, selElmnt, a, b, c;
                                let html,previoushtml, previousItem = false ;
                                /*look for any elements with the class "custom-select":*/
                                x = document.getElementsByClassName("custom-select");
                                l = x.length;
                                for (let i = 0; i < l; i++) {
                                  selElmnt = x[i].getElementsByTagName("select")[0];
                                  ll = selElmnt.length;
                                  /*for each element, create a new DIV that will act as the selected item:*/
                                  a = document.createElement("DIV");
                                                                  a.setAttribute("class", "select-selected");
                                  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
                                  x[i].appendChild(a);
                                  /*for each element, create a new DIV that will contain the option list:*/
                                  b = document.createElement("DIV");
                                                                  b.setAttribute("class", "select-items select-hide");
                                  for (let j = 1; j < ll; j++) {
                                    /*for each option in the original select element,
                                    create a new DIV that will act as an option item:*/
                                    c = document.createElement("DIV");
                                    c.innerHTML = selElmnt.options[j].innerHTML;
                                	c.setAttribute("value",selElmnt.options[j].getAttribute("value"));
                                    c.setAttribute("id",selElmnt.options[j].getAttribute("id"));
                                    c.addEventListener("click", function(e) {
                                        /*when an item is clicked, update the original select box,
                                        and the selected item:*/
                                        var y, i, k, s, h, sl, yl;
                                
                                        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                                        sl = s.length;
                                        h = this.parentNode.previousSibling;
                                        for (i = 0; i < sl; i++) {
                                		  if(this.innerHTML.includes('svg'))
                                		   html=this.innerHTML - '<svg class="checkmark" viewBox="0 0 48 48" enable-background="new 0 0 48 48"><polygon fill="#000" points="40.6,12.1 17,35.7 7.4,26.1 4.6,29 17,41.3 43.4,14.9"/></svg>';
                                		  else
                                			html=this.innerHTML;
                                          if (s.options[i].innerHTML == html) {
                                            s.selectedIndex = i;
                                            h.innerHTML = html;
                                            h.setAttribute("value",this.getAttribute("value"));
                                            y = this.parentNode.getElementsByClassName("same-as-selected");
                                            yl = y.length;
                                            for (k = 0; k < yl; k++) {		
                                			  if(y[k]){
                                				y[k].innerHTML=previoushtml;
                                			  }
                                              y[k].removeAttribute("class");
                                			  
                                            }
                                            this.setAttribute("class", "same-as-selected");
                                			previoushtml=this.innerHTML;
                                			this.innerHTML='<svg class="checkmark" viewBox="0 0 48 48" enable-background="new 0 0 48 48"><polygon fill="#000" points="40.6,12.1 17,35.7 7.4,26.1 4.6,29 17,41.3 43.4,14.9"/></svg>' + this.innerHTML;
                                            break;
                                          }
                                        }
                                        h.click();
                                    });
                                    b.appendChild(c);
                                  }
                                  x[i].appendChild(b);
                                  a.addEventListener("click", function(e) {
                                      /*when the select box is clicked, close any other select boxes,
                                      and open/close the current select box:*/
                                      e.stopPropagation();
                                      closeAllSelect(this);
                                      this.nextSibling.classList.toggle("select-hide");
                                      this.classList.toggle("select-arrow-active");
                                	
                                	if(previousItem)
                                  		previousItem.style.display = 'none';  
                                  	value = this.getAttribute("value");
                                  	currentItem = document.getElementById(`mobexpert-${value}`);
                                  	if(currentItem)
                                    	currentItem.style.display = 'block';	
                                	previousItem = currentItem; 
                                  });
                                }
                                function closeAllSelect(elmnt) {
                                  /*a function that will close all select boxes in the document,
                                  except the current select box:*/
                                  var x, y, xl, yl, arrNo = [];
                                  x = document.getElementsByClassName("select-items");
                                  y = document.getElementsByClassName("select-selected");
                                  xl = x.length;
                                  yl = y.length;
                                  for (let i = 0; i < yl; i++) {
                                    if (elmnt == y[i]) {
                                      arrNo.push(i)
                                    } else {
                                      y[i].classList.remove("select-arrow-active");
                                    }
                                  }
                                  for (let i = 0; i < xl; i++) {
                                    if (arrNo.indexOf(i)) {
                                      x[i].classList.add("select-hide");
                                    }
                                  }
                                }
                                /*if the user clicks anywhere outside the select box,
                                then close all select boxes:*/
                                document.addEventListener("click", closeAllSelect);
                              }

const submitButtonEvent = () => {
  const emailIsValid = (value) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
}

//https://regexr.com/39fv1
const phoneIsValid = (value) => {
   return /(\+4|)?(07[0-8]{1}[0-9]{1}|02[0-9]{2}|03[0-9]{2}){1}?(\s|\.|\-)?([0-9]{3}(\s|\.|\-|)){2}$/.test(value)
}

const isEmpty = (value) => {
  return (
    // null or undefined
    value == null ||
    // has length and it's zero
    (value.hasOwnProperty("length") && value.length === 0) ||
    // is an Object and has no keys
    (value.constructor === Object && Object.keys(value).length === 0) ||
    value == "" || value == " "
  );
};

const sendData = async () => {
    const magazin = document.getElementById('magazin')
    const numePrenume = document.getElementById('nume')
    const telefon = document.getElementById('telefon')
    const email = document.getElementById('email')
    const checkBox = document.getElementById('aprovs')
    const productSKU = document.querySelector("#product-sku").textContent.trim().replace(/\n/g, '')
    const productTitle = document.querySelector(".product_title").textContent
    const productURL = document.URL
    let error = false

    if(isEmpty(magazin.value)) {
      magazin.classList.add("error")
      document.querySelector("#magazin-error").classList.add("icon")
      document.querySelector("#magazin-error").innerHTML = "Este necesar sa alegi un magazin din listă"
      error = true
    } else {
      magazin.classList.remove("error")
      document.querySelector("#magazin-error").innerHTML = ""
      document.querySelector("#magazin-error").classList.remove("icon")
    }

    if(isEmpty(numePrenume.value)) {
      numePrenume.classList.add("error")
      document.querySelector("#nume-error").classList.add("icon")
      document.querySelector("#nume-error").innerHTML = "Acest câmp este obligatoriu"
      error = true
      } else {
      numePrenume.classList.remove("error")
      document.querySelector("#nume-error").innerHTML = ""
      document.querySelector("#nume-error").classList.remove("icon")
    }

      if(isEmpty(telefon.value)) {
        telefon.classList.add("error")
        document.querySelector("#telefon-error").classList.add("icon")
        document.querySelector("#telefon-error").innerHTML = "Acest câmp este obligatoriu"
        error = true
      } else if(!phoneIsValid(telefon.value)) {
        telefon.classList.add("error")
        document.querySelector("#telefon-error").classList.add("icon")
        document.querySelector("#telefon-error").innerHTML = "Numărul de telefon este invalid"
        error = true
      } else {
        telefon.classList.remove("error")
        document.querySelector("#telefon-error").innerHTML = ""
        document.querySelector("#telefon-error").classList.remove("icon")
      }

        if(isEmpty(email.value)) {
        email.classList.add("error")
        document.querySelector("#email-error").classList.add("icon")
        document.querySelector("#email-error").innerHTML = "Acest câmp este obligatoriu"
        error = true
      } else if(!emailIsValid(email.value)) {
        email.classList.add("error")
        document.querySelector("#email-error").classList.add("icon")
        document.querySelector("#email-error").innerHTML = "Adresa de email este invalidă"
        error = true
      } else {
        email.classList.remove("error")
        document.querySelector("#email-error").innerHTML = ""
        document.querySelector("#email-error").classList.remove("icon")
      }

      if(!checkBox.checked) {
        checkBox.classList.add("error")
        document.querySelector("#check-error").classList.add("icon")
        document.querySelector("#check-error").innerHTML = "Vă rugăm să confirmați că sunteți de acord cu termenii și condițiile"
        error = true
      } else {
        checkBox.classList.remove("error")
        document.querySelector("#check-error").innerHTML = ""
        document.querySelector("#check-error").classList.remove("icon")
      }
  
  const data = !error ? {
    "tip": "Produs Configurabil",
    "source": "formular-produs-configurabil-basic",
    "magazin": magazin.value,
    "numeComplet": numePrenume.value,
    "telefon": telefon.value,
    "mail": email.value,
    "gdpr": checkBox.checked,
    "productSKU": productSKU,
    "productURL": productURL,
    "productTitle": productTitle,
    "pc_tip": "ProdusConfigurabil_Basic"
    
    
  } : false
  console.log(productSKU)
    if(!isEmpty(data)) {
    const formular = document.querySelector('.formular')
    formular.classList.add("messaging")
    formular.classList.add("sending")
      
    //send request
    const response = await postData(data)
    console.log(response)

    if(response.ok == 'true') {
      return displaySuccess()
    } else {
      return displayError()
    }
  }
}

const clickButton = () => {
  const submitButton = document.getElementById('Aplica-Produs-Configurabil')


  submitButton.addEventListener("click", sendData)
}

const displaySuccess = () => {
    const formular = document.querySelector('.formular')
    formular.classList.remove("sending")
    formular.classList.add("success")
  
  //display success
    const magazin = document.getElementById('magazin')
    const numePrenume = document.getElementById('nume')
    const telefon = document.getElementById('telefon')
    const email = document.getElementById('email')
    const checkBox = document.getElementById('aprovs')

    magazin.value = ""
    numePrenume.value = ""
    telefon.value = ""
    email.value = ""
    checkBox.checked = false

  setTimeout(() => {
    formular.classList.remove("messaging")
    formular.classList.remove("success")
    closePopUp()
  }, 5000)
  
}

const displayError = () => { 
      //error
    const formular = document.querySelector('.formular')
    formular.classList.remove("sending")
    formular.classList.add("error")
}

// const sendData = async (data) => {
//   if(!isEmpty(data)) {
//     //send request
//     const response = await postData(data)
//     console.log(response)
//   }
// }

const postData = async (data) => {
  console.log(data)
  // const url = "http://localhost:5000/api/form/v1/new"
    const url = "https://api-mobexpert.herokuapp.com/api/form/v1/new"
  	const options = {
    method: "POST",
    mode: 'cors',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(data)
  }
    
    try {
    const response = await fetch(url, options)
    const data = await response.json()
    
    return data
    } catch(e) {
    	return e
    }
}

clickButton()
}

submitButtonEvent();